import {
  getActiveFunders,
  getActiveRecommenders,
  getEvaluable,
  getProposal,
} from "@engine/round/accessors";
import { RoundIsInconsistentError } from "@lib/error";
import { assert } from "@lib/utils/utils";
import type { RoundAggregate } from "./aggregate";

export function assertRoundIsConsistent(round: RoundAggregate) {
  try {
    _assertRoundIsConsistent(round);
  } catch (e) {
    throw new RoundIsInconsistentError(e as Error);
  }
}

function _assertRoundIsConsistent(round: RoundAggregate) {
  assertHasRoundAdmin(round);
  assertHasHoldProposal(round);

  // assertConsistentEvaluableIds

  // assertConsistentEvaluationEvaluables
  // assertConsistentFeedbackEvaluables
  // assertConsistentNotesEvaluables

  // const holdId = round.holdProposalId;
  // const proposalIds = Object.keys(round.proposals);
  // const spectatorIds = Object.keys(round.members).filter(
  //   (memberId) => round.members[memberId].role === "spectator",
  // );
  // const funderIds = Object.keys(round.members).filter(
  //   (memberId) => round.members[memberId].role === "funder",
  // );
  // const recommenderIds = Object.keys(round.members).filter(
  //   (memberId) => round.members[memberId].role === "recommender",
  // );

  for (let userId of Object.keys(round.members)) {
    const member = round.members[userId];

    for (const evaluationFeedbackId of Object.keys(member.evaluableFeedback)) {
      assertIsAnEvaluable(round, evaluationFeedbackId, "feedback");
    }
    for (const evaluableNotesId of Object.keys(member.evaluableNotes)) {
      assertIsAnEvaluable(round, evaluableNotesId, "evaluable notes");
    }
    // for (const evaluationId of Object.keys(member.evaluations)) {
    //   assertIsAnEvaluable(round, evaluationId, "evaluations");
    // }
    // assertIsNotNaN(member.funderBudget);
    // assertIsNotNaN(member.funderBudgetRange);

    // for (const proposalId of Object.keys(round.proposals)) {
    //   const proposal = round.proposals[proposalId];
    //   assert(
    //     proposal.min === undefined || proposal.min >= 0,
    //     "Proposal min must be nonnegative",
    //   );
    //   assert(
    //     proposal.max === undefined || proposal.max >= 0,
    //     "Proposal max must be nonnegative",
    //   );
    // }
  }

  // for (const spectatorId of spectatorIds) {
  //   const spectator = round.members[spectatorId];
  //   assertIsSubset(
  //     Object.keys(spectator.evaluations),
  //     [holdId],
  //     "Spectators can't evaluate anything",
  //   );
  // }
  // for (const funderId of funderIds) {
  //   const funder = round.members[funderId];
  //   assertIsSubset(
  //     [holdId],
  //     Object.keys(funder.evaluations),
  //     "Funders must evaluate Hold",
  //   );
  //   assertIsSubset(
  //     Object.keys(funder.evaluations),
  //     [holdId, ...recommenderIds],
  //     "Funders can only evaluate recommenders",
  //   );
  // }
  // for (const recommenderId of recommenderIds) {
  //   const recommender = round.members[recommenderId];
  //   assertIsSubset(
  //     [holdId],
  //     Object.keys(recommender.evaluations),
  //     "Recommenders must evaluate Hold",
  //   );
  //   assertIsSubset(
  //     Object.keys(recommender.evaluations),
  //     [holdId, ...proposalIds],
  //     "Recommenders can only evaluate proposals",
  //   );
  // }
}

function assertHasRoundAdmin(round: RoundAggregate) {
  assert(
    Object.values(round.members).some(
      (member) => member.isRoundAdmin && member.status === "active",
    ),
    "Round must have at least one admin",
  );
}

function assertHasHoldProposal(round: RoundAggregate) {
  const holdProposal = getProposal(round, round.holdProposalId);
  assert(!!holdProposal, `Round must have a hold proposal`);
  assert(holdProposal!.status === "active", "Hold proposal can't be deleted");
}

// evaluation status for role

function assertIsAnEvaluable(
  round: RoundAggregate,
  evaluableId: string,
  message: string,
) {
  const evaluable = getEvaluable(round, evaluableId);
  if (evaluable) {
    return;
  }

  assert(false, `Not an evaluable: ${evaluableId} (${message})`);
}

// function assertIsDateString(dateString: string) {
//   // TODO
// }
//
// function assertIsPositive(n: number, description: string) {
//   assert(n > 0, `${description} should be positive`);
// }
//
// function assertIsNotNaN(n: number) {
//   assert(isFinite(n), "Expected a number");
// }
//
// function assertIsSubset<T>(smaller: T[], larger: T[], message: string) {
//   for (const element of smaller) {
//     assert(larger.includes(element), message);
//   }
// }

// TODO: we should not need this function
export function roundIsReadyToEvaluate(round: RoundAggregate): {
  isReady: boolean;
  reasonsWhyNot: string[];
} {
  const reasonsWhyNot: string[] = [];
  try {
    assertRoundIsConsistent(round);
  } catch (e) {
    return {
      isReady: false,
      reasonsWhyNot: [(e as Error).message],
    };
  }

  const recommenders = getActiveRecommenders(round);
  const funders = getActiveFunders(round);

  if (!recommenders.length) {
    reasonsWhyNot.push("You need at least one recommender");
  }
  if (!funders.length) {
    reasonsWhyNot.push("You need at least one funder");
  }

  return {
    isReady: reasonsWhyNot.length === 0,
    reasonsWhyNot,
  };
}
